<template>
  <div class="container-fluid">
    <div class="heightcontainer">
        <landing-navbar></landing-navbar>
        <selected-job-details></selected-job-details>
    </div>    
    <Footer class="footer" ></Footer>
  </div> 
</template>
<script>
import Footer from '../LandingFooter.vue'
import selectedJobDetails from '../../components/SelectedJobDetails.vue'
import router from '../../router.js'
import LandingNavbar from './Navbar.vue'
import $ from 'jquery'
export default {
  components: {
    Footer,
    LandingNavbar,
    selectedJobDetails
  },
  data() {
    return {
    };
  },
  methods: {
  },
  mounted: function() {
    window.scrollTo(0, 0)
  },
};
</script>
<style scoped>
section {
 margin: 0 0 0rem 0rem  !important ;
}
.footer {
  background-color: black;       
  color : white;
  position: sticky;
}
@media screen and (min-width : 768px) {
    
}
</style>
